// extracted by mini-css-extract-plugin
export default {"body":"BlockedModal_body__kJVy2"};